export const CODE_ERRORS = {
  NOT_FOUND: 404,
  PRECONDITION_FAILED: 412,
  INTERNAL_SERVER_ERROR: 500,
};